document.addEventListener('DOMContentLoaded', function() {
  const apiUrl = 'https://api.hibonsai.com/rest/org/ai/5f670899-dd82-4ef9-96f7-da8a3c2ad607/'; 
  const contentDiv = document.getElementById('dynamic-markdown-content');

  fetch(apiUrl)
    .then(response => {
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }
      return response.text(); // or .json() if it's JSON-wrapped
    })
    .then(markdown => {
      const html = marked.parse(markdown); // Convert MD to HTML
      contentDiv.innerHTML = html;
    })
    .catch(error => {
      contentDiv.innerHTML = 'Error loading content: ' + error.message;
    });
});